<template>
  <main class="flex-item">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">format_list_bulleted</span>契約一覧</p>
      </header>
      <div class="card-content">
        <div class="columns" v-if="searchRes.kei01p !== null">
          <div class="column">
            <div class="card contract-item">
              <div class="card-content">
                <nav class="level is-mobile">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <router-link class="button is-primary" :to="{ name: 'Contract' }">
                        <span>契約照会はこちら</span>
                      </router-link>
                    </div>
                    <div class="level-item" v-if="searchRes.rnw01p !== null">
                      <!-- 更新手続画面遷移処理 -->
                      <router-link
                        v-if="searchRes.rnw01p?.tf_rekzis !== constants.KEIZOKU_ISHI.ARI"
                        class="button is-warning"
                        :to="{ name: 'DisclosureStatement' }"
                      >
                        <span>更新手続きはこちら</span>
                      </router-link>
                      <button v-else class="button is-warning" disabled>
                        <span>更新手続き済</span>
                      </button>
                    </div>
                  </div>
                </nav>
                <div class="columns is-multiline">
                  <div class="column is-3-desktop is-3-widescreen is-3-fullhd is-4-tablet is-12-mobile">
                    <div class="is-italic">証券番号</div>
                    <div>{{ searchRes.kei01p?.tf_kekeno }}</div>
                  </div>
                  <div class="column is-3-desktop is-3-widescreen is-3-fullhd is-4-tablet is-12-mobile">
                    <div class="is-italic">契約期間</div>
                    <div>{{ searchRes.kei01p?.tf_keskdt }}～{{ searchRes.kei01p?.tf_kemkdt }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns" v-if="searchRes.kei01p === null && searchRes.rnw01p === null">
          <div class="column">
            <div class="card contract-item">
              <div class="card-content">表示する契約がありません</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { getSearchResponse, searchResponse } from "@/api/search";
import { defineComponent, reactive, UnwrapRef } from "vue";
import constants from "common/src/constants";

export default defineComponent({
  setup() {
    const searchRes: UnwrapRef<searchResponse> = reactive({
      kei01p: null,
      rnw01p: null,
    });

    getSearchResponse()
      .then((r) => {
        searchRes.kei01p = r.data.kei01p;
        searchRes.rnw01p = r.data.rnw01p;
      })
      .catch(() => {
        return;
      });

    return {
      searchRes,
      constants,
    };
  },
});
</script>
